module.exports = __webpack_public_path__ + "media/customizations/terramor/logo-new-f74b20867e54a956cb7dd27d7ed99c63.png";